import { statsData } from '@/mocks/manga';

export default function StatsSection() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
        {statsData.map((stat) => (
          <div key={stat.label} className="text-center">
            <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
              <i className={`${stat.icon} text-accent-600 text-xl`}></i>
            </div>
            <p className="font-heading text-3xl md:text-4xl font-black text-foreground-900 mb-1">
              {stat.value}
            </p>
            <p className="text-sm text-foreground-500">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}